
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.697","height":"24.696","viewBox":"0 0 24.697 24.696"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_73","data-name":"Group 73","transform":"translate(-165.198 -132.935)"}},[_c('g',{attrs:{"id":"Group_9","data-name":"Group 9"}},[_c('g',{attrs:{"id":"Group_8","data-name":"Group 8"}},[_c('circle',{attrs:{"id":"Ellipse_4","data-name":"Ellipse 4","cx":"12.348","cy":"12.348","r":"12.348","transform":"translate(165.198 132.935)","fill":"#fff"}})])]),_c('path',{attrs:{"id":"Path_8","data-name":"Path 8","d":"M183.551,143.626c-.1.01-.21.016-.316.016a3.431,3.431,0,0,1-2.871-1.552v5.284a3.9,3.9,0,1,1-3.9-3.9h0c.081,0,.161.007.241.012v1.925a1.927,1.927,0,0,0-.241-.025,1.993,1.993,0,0,0,0,3.987,2.042,2.042,0,0,0,2.073-1.969l.019-8.973h1.842a3.427,3.427,0,0,0,3.16,3.061v2.139","fill":"#fd7e14"}})])])
          )
        }
      }
    